<template>
  <div class="page">
    <div class="tipDiv">
      <p>若您在线申请过版面定制公交卡，可查询办卡进度</p>
    </div>
    <b-container fluid>
      <div>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">姓名</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="name"
              id="input-name"
              type="text"
              placeholder="办卡人姓名"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="办卡预留手机号"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />

        <!-- <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              block
              @click="queryBankSn()"
              variant="danger"
              :disabled="disabled"
              >查询</b-button
            >
          </b-col>
        </b-row> -->

        <!-- 同意协议 -->
        <b-row>
          <b-col cols="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />
          </b-col>
          <b-col>
            我已阅读
            <!-- <font color="red" @click="showRules()"
              >《合肥通DIY卡使用章程》</font> -->
            <font color="red" @click="HBAppagreement()">《隐私政策》</font
            ><font color="red" @click="HBAppagreementDE()"
              >《用户服务协议》</font
            >并同意相关内容。
          </b-col>
        </b-row>
        <!-- 同意协议 -->
        <!-- <b-row class="rowItemFee">
          <b-col cols="1"> </b-col>
          <b-col> 下一步将提交申请图片进行处理及卡片费用结算。 </b-col>
        </b-row> -->
        <!-- 下一步 -->
        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              block
              variant="danger"
              :disabled="disabled"
              @click="queryBankSn()"
              >下一步</b-button
            >
          </b-col>
        </b-row>
      </div>
      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">查询中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
      <b-modal
        ref="HBAppagreementDE"
        ok-only
        scrollable
        title="用户服务协议"
        ok-title="确定"
      >
        <div class="confirmation">
          <div class="content">
            <div class="title">用户服务协议</div>
            <div class="one_leave">尊敬的用户：</div>
            <ul class="section">
              <li class="text">
                感谢您选择我们提供的合肥通服务。本协议(以下简称“本协议”)由恒宝股份有限公司(以下简称“恒宝”或“我们”)与用户(以下简称“用户”或“您”)签订。
              </li>
              <li class="text">一.服务协议的确认</li>
              <li class="text">
                1.本协议有助于您了解我们为您提供的服务内容及您使用服务的权利和义务，请您仔细阅读。
              </li>
              <li class="text">
                2.您一旦访问、安装、复制、下载或以其它方式使用本软件，即表示您同意接受本协议各项条款的约束。如您不同意本协议中的条款，请不要使用本软件。
              </li>
              <li class="text">
                3.如您为无民事行为能力人或为限制民事行为能力人，请告知您的监护人，并在您的监护人的指导下阅读本协议和使用我们服务。
              </li>
              <li class="text">一.使用合肥通服务的注意事项</li>
              <li class="text">1.身份验证</li>
              <li class="text">
                (1)
                您在注册、使用合肥通服务的过程中，请您提供合法、真实、有效、准确并完整的资料(包括但不限于身份证、姓名、手机号码、通讯地址等)。为了及时有效地验证您的信息(包括但不限于身份信息、账户信息)，根据法律法规及监管规定或合肥通认为有需要时，您同意我们可以把您的信息提供给第三方，也同意第三方可以把您的信息提供给合肥通，以便合肥通进行验证。您应确保合肥通登录名、账户绑定的合肥通账号或手机号均为您本人持有，如您占用了他人的合肥通账号或手机号的，为避免给合肥通账号或手机号持有人带来不便或不利影响，也为了您的资金安全，合肥通可能将合肥通账号或手机号从您的账户中注销并解除关联。
              </li>
              <li class="text">
                (2)
                为了满足相关法律法规规定的要求，您同意按照合肥通的要求及通知的时间提供您的身份信息以完成身份验证，否则您可能无法使用合肥通。
              </li>
              <li class="text">
                2.存在如下情形时，我们会对您合肥通账户暂停或终止提供合肥通，且有权限制您所使用的产品或服务功能(包括但不限于对账户名下的虚拟账户款项和交易采取止付、取消交易、调账等限制措施):
              </li>
              <li class="text">(1) 您违反了本协议的约定;</li>
              <li class="text">(2) 根据法律法规及法律文书的规定;</li>
              <li class="text">
                (3)
                根据有权机关(指依照法律法规等有权的单位，包括但不限于公安机关、检察院、法院、海关、税务机关)的要求;
              </li>
              <li class="text">
                (4) 您的合肥通账户操作、资金流向等存在异常时;
              </li>
              <li class="text">(5) 您的合肥通账户可能产生风险的;</li>
              <li class="text">
                (6) 他人向您合肥通账户错误汇入资金等导致您可能存在不当获利的;
              </li>
              <li class="text">
                (7) 您遭到他人投诉，且对方已经提供了一定证据的;
              </li>
              <li class="text">
                (8)
                您可能错误地操作他人合肥通会员号或账户，或将他人会员号或账户进行了身份验证的。
              </li>
              <li class="text">
                3.您认可合肥通会员号或账户的使用记录截屏内容可能涉及隐私，请妥善保管，已录为准。如您对该等数据存有异议的，可及时向合肥通提出议，并提供相关证据供合肥通核实。
              </li>
              <li class="text">
                4.对于您提供及发布文字、图片、视频、音频等非个人隐私信息，在版权保护期内您免费授予我们及其关联公司获得全球排他许可使用权利及再授权给其他第三方使用的权利。您同意我们及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人隐私信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其他作品内。
              </li>
              <li class="text">
                5.您在使用合肥通服务过程中，本协议内容、网页上出现的关于操作的提示或合肥通发送到手机的信息内容是您使用合肥通服务的相关规则。
              </li>
              <li class="text">6.服务咨询与投诉</li>
              <li class="text">
                (1)您在使用合肥通服务过程中，如遇到问题，您可以通过以下方式联系我们：
              </li>
              <li class="text">1)发送邮件到: hftdiy@hengbao.com;</li>
              <li class="text">2)拨打客户热线: 0551-62658114;</li>
              <li class="text">
                (2)如您被他人投诉或投诉他人，我们将有权将您的主体信息、联系方式、投诉相关的内容等必要信息提供给争议向对方或相关部门，以便及时解决投诉纠纷，以保护您及他人的合法权益;但法律法规另有规定的除外。
              </li>
              <li class="text">三、用户合法使用合肥通服务的承诺</li>
              <li class="text">
                1.您应遵守中华人民共和国相关法律法规及您所属、所居住的国家或地区的法律法规，不得将合肥通服务用于任何非法目的(包括用于禁止或限制交易物品的交易)，也不得以任何非法方式使用合肥通服务。
              </li>
              <li class="text">
                2.您不得利用合肥通服务从事侵害他人合法权益之行为或违反国家法律法规，否则合肥通有权进行调查或停止提供合肥通服务，且您应独立承担所有相关法律责任，因此导致合肥通或合肥通雇员或其他方受损的，您应承担赔偿责任。
              </li>
              <li class="text">3.上述1和2适用的情况包括但不限于：</li>
              <li class="text">
                (1)
                侵害他人名誉权、隐私权、商业秘密商标权、著作权、专利权等合法权益。
              </li>
              <li class="text">(2) 违反依法定或约定之保密义务。</li>
              <li class="text">(3) 冒用他人名义使用合肥通服务。</li>
              <li class="text">
                (4)从事不法交易行为或合肥通认为不得使用合肥通服务进行交易的。
              </li>
              <li class="text">
                (5) 从事任何可能侵害合肥通服务系统、数据之行为。
              </li>
              <li class="text">
                4.合肥通服务有赖于系统的准确运行及操作。若出现系统差错、故障或其他原因引发的展示错误、您或合肥通不当获利等情形，您同意合肥通可以采取更正差错、扣划款项等适当纠正措施。
              </li>
              <li class="text">
                5.您不得对合肥通系统和程序采取反向工程手段进行破解，不得对上述系统和程序(包括但不限于源程序、目标程序、技术文档、客户端至服务器端的数据、服务器数据)进行复制、修改、编译、整合或篡改，不得修改或增减合肥通系统的任何功能，不得以任何方式干扰或尝试干扰本合肥通系统及服务任何部分或功能的正常运行。
              </li>
              <li class="text">四、不可抗力、免责及责任限制</li>
              <li class="text">1.不可抗力</li>
              <li class="text">
                您需要理解并同意，在使用本合肥通系统及关联服务的过程中，可能会遇到不可抗力等风险因素，使本合肥通系统能够提供的全部或部分服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失，我们不予承担。
              </li>
              <li class="text">2.免责条款</li>
              <li class="text">
                (1)
                如因国家政策及法规的变更或其它任何原因，本合肥通系统有可能变更、中断、终止部分或全部的服务。在此类情形下，恒宝一般会在适当的时机通过弹出消息或其它方式对您进行通知，并告知您变更、中断、终止部分或全部的服务时间及内容。恒宝不对因变更、中断、终止部分或全部的服务之事项对用户或第三方承担任何责任。
              </li>
              <li class="text">
                (2)
                合肥通需要定期或不定期地进行升级、维护，我们将尽量维持服务的不中断，但如果因技术原因或其它原因造成服务在合理时间内的中断，我们将尽可能事先对您进行通告，但无需为此承担任何责任。
              </li>
              <li class="text">
                (3)
                合肥通在变更服务或部分功能时，您在本服务中储存的信息可能将被删除且无法恢复，我们将尽可能事先对您进行通告，您可在一定时间内备份您的信息数据，在指定的日期后，本合肥通系统将可能不再保存、维护您的这部分信息及数据，并无需为此承担任何责任。
              </li>
              <li class="text">
                (4)我们将尽可能保证本合肥通的运行及提供的服务能够满足并适应您的要求，但对此不做承诺。并且，我们无法保证本合肥通为您提供的服务不受干扰，其完全安全、可靠或不出现错误，但我们会对通过任何方式发现的问题予以尽可能的修复。
              </li>
              <li class="text">
                (5)
                如因您的终端设备丢失、终端设备故障、终端设备感染病毒、木马或其他恶意程序、黑客攻击、终端设备搭载的操作系统漏洞、网络及通讯服务故障、操作不当、您当前使用的软件版本未及时升级更新、终端设备兼容性问题、其它不可预见的问题或故障、由您单方面原因造成的账户信息泄露等原因造成的财产损失、数据泄露、数据损失及其它可能产生的损失，恒宝不承担任何相关责任。
              </li>
              <li class="text">3.合肥通责任范围及责任限制</li>
              <li class="text">
                合肥通用户信息是由用户本人自行提供的，合肥通无法保证该信息之准确有效和完整。
              </li>
              <li class="text">五、知识产权的保护</li>
              <li class="text">
                1.本软件上所有内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计，均由我们依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
              </li>
              <li class="text">
                2.未经我们书面同意，任何人不得擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表本软件程序或内容。
              </li>
              <li class="text">六、其他</li>
              <li class="text">
                1.本协议的签订、执行、条款、解释及争议的解决均应适用中华人民共和国法律。如协议双方就本协议内容或执行方式发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向恒宝注册地有管辖权的人民法院提起诉讼。
              </li>
              <li class="text">
                2.如果恒宝未执行或未行使包含在本协议中的任何或某一法定权利，并不能视为恒宝对该权利的放弃，这些权利仍对恒宝有效。同样，如您未执行或未行使包含在本协议中的任何或某一法定权利，这些权利仍对您有效。
              </li>
              <li class="text">
                3.如因国家法律法规变更、第三方原因、不可抗力等因素造成的本协议中的任何条款完全或部分无效或不可执行，本协议中的其余条款仍然有效并且具有约束力。
              </li>
              <li class="text">
                4.本协议构成双方认可本协议之约定事项及条款内容，除此之外，本协议未赋予各方其它权利。但本协议涉及的所有事项、条款的遵守及执行，若与国家法律法规相悖、冲突、或存在争议，将以国家法律法规颁布的内容为准。
              </li>
            </ul>
          </div>
        </div>
      </b-modal>
      <!-- 小程序开发协议 -->
      <b-modal
        ref="HBAppagreement"
        ok-only
        scrollable
        title="隐私政策"
        ok-title="确定"
      >
        <div
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <div class="confirmation">
            <div class="content">
              <div class="title">隐私协议</div>
              <div class="one_leave">尊敬的用户：</div>
              <ul class="section">
                <li class="text">
                  感谢您选择我们提供的服务。本隐私政策(以下简称“本政策”)由恒宝股份有限公司(以下简称“恒宝”或“我们”)与用户(以下简称“用户”或您”)制定。
                </li>
                <li class="text">1. 适用范围</li>
                <li class="text">
                  本隐私政策适用于所有接受、使用、享受我们服务的用户，您如果登录我们的服务平台，即视为同意接受本政策的约束。
                </li>
                <li class="text">
                  本政策应当在当地法律最大允许范围内保持完整和有效。
                </li>
                <li class="text">2.我们如何收集及使用您的个人信息</li>
                <li class="text">2.1信息收集的目的</li>
                <li class="text">
                  (1)我们收集个人信息的目的是为了实现我们的核心业务功能、附加业务功能及合作业务功能。
                </li>
                <li class="text">
                  (2)若我们将您的个人信息用于本政策未列明的其他用途或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的明确同意或授权。
                </li>
                <li class="text">2.2信息收集的方式</li>
                <li class="text">
                  我们出于本政策所述目的，可能会收集、保存和使用下列与您有关的信息。如果您不提供相关信息，您将无法享受相关的服务。为了给您提供更好的服务，您同意我们按照如下方式收集信息:
                </li>
                <li class="text">(1)用户提供的信息</li>
                <li class="text">
                  在某些页面上，我们会要求您输入个人信息，以便根据您提出的要求提供服务或进行交易。我们并不要求您必须提供特定的个人信息，但是如果没有这些信息，我们可能无法应您的要求为您提供服务或完成交易。
                </li>
                <li class="text">(2)第三方提供的信息</li>
                <li class="text">
                  我们从第三方获取信息的前提是征得您的同意或者第三方依法被要求或许可我们正当使用您的信息。我们承诺在合法、正当、必要的范围内使用从第三方获取的信息，遵循有限处理相关且必要信息的原则并确保准确性与保密性。
                </li>
                <li class="text">2.3信息收集及使用的功能场合</li>
                <li class="text">(1)您的个人信息将被我们用于以下场合：</li>
                <li class="text">
                  与合肥通相关的用户注册、查询、充值、挂失、解挂、身份验证、消费、缴费、订餐等线上线下服务;
                </li>
                <li class="text">(2)注册成为我们的用户并登录</li>
                <li class="text">
                  如果您注册成为我们的平台用户，您需要提供手机号或我们支持的第三方账号进行登录，便于我们为您提供服务;如您进行合肥通身份验证，需要收集您的姓名、证件类型、证件号码以及与身份信息对应的且可通话联络的手机号码。如果您需要使用刷脸识别，您需要提供您的生物识别信息(人脸信息)。
                </li>
                <li class="text">(3)特定扩展功能</li>
                <li class="text">
                  需要您在您的设备中向我们开启您设备的访问权限:
                </li>
                <li class="text">
                  相机/摄像头权限:如您需要使用扫描收款码、人脸验证功能，请开启相机使用权限。
                </li>
                <li class="text">
                  相册/图片库权限:如您需要使用保存、上传功能，请开启相册权限。
                </li>
                <li class="text">
                  推送权限：如您需要接收我们发送给您的通知信息，请开启推送权限。
                </li>
                <li class="text">
                  请您注意:您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
                </li>
                <li class="text">(4)保障您的交易安全</li>
                <li class="text">
                  为提高您使用我们提供服务的安全性，确保操作环境安全与识别注册账号异常状态，更好地保护您或其他用户或公众的人身安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反中华人民共和国法律法规或合肥通相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、位置信息、日志信息以及我们合作伙伴取得您授权或依据法律共享的信息，来综合判断您的账户的交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录，审计、分析、处置措施。
                </li>
                <li class="text">(5)其他用途</li>
                <li class="text">
                  请您知悉并同意，我们有权使用已经去标识化的信息，在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用，用于改善我们的服务内容和产品布局，为商业决策提供支撑，以及改进我们的产品和服务。
                </li>
                <li class="text">2.4信息收集类型</li>
                <li class="text">(1)我们通过上述方式收集到的个人信息类型:</li>
                <li class="text">
                  详细联系信息:姓名(中文+英文)电话/手机号码、地理位置;
                </li>
                <li class="text">详细个人信息:性别、出生日期、民族、国籍;</li>
                <li class="text">生物识别信息:面部识别特征;</li>
                <li class="text">个人身份证明:身份证;</li>
                <li class="text">
                  网络身份标识信息:合肥通账号、IP地址、设备号及与前述有关的密码等信息;
                </li>
                <li class="text">
                  (2)我们会尽量采取合理可行的技术措施避免收集与您所需服务不相关的个人信息。
                </li>
                <li class="text">3.我们如何共享、转让、公开披露您的个人信息</li>
                <li class="text">
                  根据中华人民共和国法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
                </li>
                <li class="text">3.1信息共享</li>
                <li class="text">
                  为实现您通过合肥通或经合肥通跳转后选择的服务，为提高我们的服务质量，我们会在合法、必要的范围内，将您的信息在服务提供商、技术运营者、我们的关联公司及合作服务商之间进行共享，以便于我们提供更便捷、更安全的服务。我们承诺只会共享必要的个人信息且受本隐私权政策中所声明的目的的约束，如果我们的共享行为或接收方超出授权范围改变个人信息的使用及处理目的，我们将以显著提示方式再次征求您的授权同意或要求接收方重新获得您的授权同意。
                </li>
                <li class="text">3.2信息转让</li>
                <li class="text">
                  我们将不会向任何组织、公司和个人转让您的个人信息，除非在以下情况下或为了以下目的:
                </li>
                <li class="text">(1)已取得用户的同意;</li>
                <li class="text">
                  (2)依照法律法规、法律程序、强制性的司法或行政要求等进行提供;
                </li>
                <li class="text">
                  (3)在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                </li>
                <li class="text">3.3公开披露</li>
                <li class="text">
                  我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
                </li>
                <li class="text">
                  (1)获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
                </li>
                <li class="text">
                  (2)根据法律、法规、规章及其他规范性文件等的要求、强制性的行政、执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于行政、司法、执法部门因特定调查目的且有合法权利获取的数据。
                </li>
                <li class="text">
                  (3)如果我们确定您出现违反法律法规或严重违反本合肥通系统及/或服务相关协议及规则的情况，或为保护本合肥通系统及/或服务及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或本合肥通系统及/或服务相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及本合肥通系统及/或服务已对您采取的措施。
                </li>
                <li class="text">4.我们如何存储个人信息</li>
                <li class="text">
                  (1)您的个人信息将会被存储于中华人民共和国境内。如基于其它必要的业务需将您的个人信息传输至境外，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
                </li>
                <li class="text">
                  (2)适用法律法规允许的最大期限:我们承诺仅在本政策所述目的所必需期间和法律法规及监管规定的时限内存储您的个人信息。我们不会将您的个人信息保留超过处理目的所需的时间，并将根据我们的数据保留政策为收集的目的而保留必要的时间，除非需要延长保留期或受到法律的允许。
                </li>
                <li class="text">5.我们如何保护个人信息</li>
                <li class="text">
                  (1)我们将妥善管理和保护您的个人信息，按照并采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，极为谨慎地防止您的个人信息遭到未经授权地访问、泄露、使用、篡改、损坏或丢失。您也需妥善保管登陆的账号和密码。通过您的账号和密码进行的操作，我们将默认是您本人的操作。
                </li>
                <li class="text">
                  (2)如果不幸发生个人信息安全事件后，我们将按照法律法规的要求及时通知您:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式通知您，难以逐一通知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们将按照监管部门要求，上报个人信息安全事件的处置情况。
                </li>
                <li class="text">
                  (3)如果您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策约定的联系方式联络我们，以便我们采取相应措施，请不要私自尝试或验证弱点。
                </li>
                <li class="text">6.您的权利：</li>
                <li class="text">
                  (1)知情权:我们在收集和获取您的个人信息时，向您提供相关途径以便您知晓我们的身份、我们对您个人信息收集处理目的、方式、范围、权利维护途径等内容，并经过您的同意。
                </li>
                <li class="text">
                  (2)访问权:您有权从我们这里确认您的个人信息以及知悉您的个人信息是否被处理、处理目的、保留时间等内容。
                </li>
                <li class="text">
                  (3)更正权:您有权要求我们更正与您个人信息相关的不准确的数据。
                </li>
                <li class="text">
                  (4)删除权:您有权要求我们删除与您有关的个人信息，且在特定情形下我们有义务删除您的个人信息。请您注意:出于您所在的单位的审计需求，您在系统内的交易记录将被保留，除非您依法要求您所在单位的管理员从系统彻底删除您的相关数据。
                </li>
                <li class="text">
                  (5)拒绝权:您有权以正当理由反对我们对您的个人信息进行处理
                </li>
                <li class="text">7.未成年人的信息保护</li>
                <li class="text">
                  (1)我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人(如果当地法律对于未成年人界定有异或发生变化我们会尽量遵守;如果您有任何困惑，请及时告知我们)，在使用我们的服务前，应事先取得您父母或法定监护人的同意。我们根据《中华人民共和国未成年人保护法》等国家相关法律法规的规定保护未成年人的个人信息。
                </li>
                <li class="text">
                  (2)对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用公开披露此信息。
                </li>
                <li class="text">
                  (3)如果我们发现未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
                </li>
                <li class="text">8.隐私政策的依据与更新</li>
                <li class="text">(1)依据</li>
                <li class="text">
                  本政策依据《民法典》、《消费者权益保护法》、《网络安全法》、《信息安全技术个人信息安全规范》，网信办、工信部等监管部门颁布的政策文件或推荐性指南文件，进行了相应的修改和完善。
                </li>
                <li class="text">(2)更新</li>
                <li class="text">
                  在上述法律法规允许范围内，我们保留根据实际情况随时修改隐私政策的权利，隐私政策的最新版本将会在合肥通平上公布，同时公布更新的日期，以便您了解最新的隐私政策。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。
                </li>
                <li class="text">
                  我们承诺:除非法律法规等强制性规定的变化所要求，未经您明确授权同意(包括其他贵我双方之间协议中的授权)，我们不会实质性限制或减少您按照本政策所应享有的权利。
                </li>
                <li class="text">9.您如何联系我们</li>
                <li class="text">
                  (1)如果您对本政策或您个人信息的相关事宜有任何疑问、意见或建议，请通过以下方式联系我们：
                </li>
                <li class="text">1）发送邮件 hftdiy@hengbao.com;</li>
                <li class="text">2）拨打客服电话 0551-62658114。</li>
                <li class="text">
                  (2)一般情况下，我们将在30天内回复您。如果您对回复不满意或认为我们的个人信息处理方式损害了您的合法权益，您还可以向网信、公安及工商等监管部门进行投诉或举报。
                </li>
                <li class="text">
                  (3)上述安排不影响您通过向本公司住所地区有管辖权的人民法院提起诉讼来寻求解决方案。
                </li>
                <li class="text">10.其他</li>
                <li class="text">
                  在用户接受合肥通任一服务的情况下，本政策构成该服务的协议关系(无论协议以口头、书面或其他方式达成)的组成部分并应与相关服务协议一并考虑，在此情况下，除非相关服务协议明确予以排除其适用，本隐私政策应得到优先适用。个人信息因为我们需要遵守法律要求、不可抗力因素、技术限制等客观原因而不幸泄漏的，我们不应对于用户因此可能遭受的损失承担赔偿责任;在有明确可归责的第三方的情况下，我们将协助用户向第三方追究责任。如果我们违反了法律要求，公司或者有关责任人员，应该依法承担所有法律责任，包括可能的行政处罚甚至刑事责任。但在索赔发生当时法律未禁止的任何情况下，就基于本政策和相关服务协议的约定的索赔而言，除非经证实我们违反了法律强制性规定或者对于造成损失存有故意或重大过失，我们对于用户因为个人信息泄漏遭受损失的赔偿责任以补偿用户的实际损失为限(任何无法证实或未经证实的损失或不合理的相关费用或支出均不得被认定为实际损失)，且不得超过我们实际收到的相关服务收费的两倍。在无法区分具体服务或我们并未对服务进行收费的情况下，我们在上述单一违约投诉/索赔事件的责任限制以人民币100元为限。上述赔偿承诺是基于用户自身并无过错的假设。如果用户对于损失有过错，则应相应减轻或免除我们的责任。为避免争议，如果用户未能及时地通知我们或采取其他可合理期待的止损措施，对于可能因此扩大的损失，我们有权主张免于承担赔偿责任;我们不对用户的纯粹的精神损害承诺进行赔偿。就隐私政策的有效性、解释及适用所引发的一切纠纷均应适用中国法律并接受我们住所地管辖权的法院排他的诉讼管辖权。为本条目的，“中国法律”应在法律允许的最大范围内不包括可能导致中国以外实体法得以适用的任何法律或其一部分。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
import { mobile_pattern } from "@/js/verifyData";
export default {
  name: "QueryOrder_hf",
  data() {
    return {
      name: "",
      mobile: "",
      disabled: true,
      loading: false,
      showToast: false,
      toastMsg: "",
      status: "not_accepted",
    };
  },
  watch: {
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    name: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (this.name.length > 0 && this.mobile.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    mobile: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (this.mobile.length > 0 && this.name.length > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  methods: {
    HBAppagreement: function () {
      this.$refs["HBAppagreement"].show();
    },
    HBAppagreementDE: function () {
      this.$refs["HBAppagreementDE"].show();
    },
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    queryBankSn: function () {
      const pattMobile = mobile_pattern;
      if (
        this.name.length == 0 ||
        this.name.length < 2 ||
        this.name.length > 15
      ) {
        this.showToastMsg("您输入的姓名长度不符合要求，请重新输入");
        return;
      }

      if (!pattMobile.test(this.mobile)) {
        this.showToastMsg("请输入正确的手机号");
        return;
      }

      var that = this;
      let param = {
        clientName: this.name,
        clientPhoneNumber: this.mobile,
        bankCode: config.config_hf.bankCode,
      };
      console.log("param------>", param);
      that.showLoading();
      axios
        .post(config.config_hf.queryBankSerialNumbers, param)
        .then(function (response) {
          console.log(response);
          let data = response.data;
          if (data.code == 0) {
            console.log("serialNumberList--->", data.serialList);
            that.toOrderList(data.serialList);
          } else {
            that.hideLoading();
            that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    queryOrder: function (data) {
      let bankCodeList = new Set();
      let set = new Set();

      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        set.add(item.bankCode);
      }

      for (var bankCode of set) {
        // 遍历Set
        var item = new Object();
        item.bankCode = bankCode;
        item.serialList = new Set();

        for (var codeAndSerial of data) {
          var tempBankCode = codeAndSerial.bankCode;
          if (item.bankCode == tempBankCode) {
            item.serialList.add(codeAndSerial.bankSerialNumber);
          }
        }
        bankCodeList.add(item);
      }

      console.log(JSON.stringify(bankCodeList));

      let params = {
        bankCodeList: bankCodeList,
        pageIndex: 0,
        pageSize: 4,
      };
      console.log("params--->", params);
      var that = this;
      axios
        .post(config.config_hf.queryOrder, params)
        .then(function (response) {
          /* {
              "code": 0,
              "message": null,
              "projectName": "DIY",
              "orderModelList": [{
                "orderNo": "01222404618637029376",
                "orderDateTime": "2020-03-10 14:12:50",
                "orderStatus": "制卡完成",
                "orderStatsNo": 8,
                "courierCompany": "",
                "trackNumber": "",
                "orderType": "1",
                "price": 1,
                "auditFailCause": null,
                "modelType": 0,
                "modelClass": 0,
                "backgroundColor": "201C",
                "cardClass": 1,
                "address": "北京市西城区新盛大厦B-8层",
                "orderStep": 3,
                "cardTypeName": "借记卡",
                "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
              }]
            } */
          that.hideLoading();
          console.log(response);
          var data = response.data;
          var dataString = JSON.stringify(data);
          console.log(dataString);

          if (data.code == 0) {
            var orders = data.orderModelList;
            var obj = {
              projectName: data.projectName,
              orders: orders,
            };
            that.toOrderList(obj);
          } else {
            that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    toOrderList: function (bankSerialObj) {
      var queryResult = JSON.stringify(bankSerialObj);
      this.$router.push({
        name: "OrderList_hf",
        params: {
          bankSerialObj: queryResult,
        },
      });
    },
  },
};
</script>

<style scoped>
.page {
  margin-top: 4vh;
}

.rowBtn {
  margin-top: 3rem;
}

.tipDiv {
  padding-left: 16px;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/hefeibank/QueryOrder_hf.vue